import circleBaseBtn from "@assets/imgs/btns/circle-base-btn.png";

import { AudioManager } from "@/phaser/core/audio/AudioManager";
import { BaseButton } from "@phaser/ui/btns/BaseButton";

interface LanguageBtnOptions {
  label: string;
  onClick: () => void;
}

export class LanguageBtn extends BaseButton {
  private bg: Phaser.GameObjects.Image;
  private labelText: Phaser.GameObjects.Text;

  static preload(scene: Phaser.Scene) {
    scene.load.image("circle-base-btn", circleBaseBtn);
  }

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    options: LanguageBtnOptions,
  ) {
    super(scene, x, y, {
      onClick: options.onClick,

      sfx: () => AudioManager.playSfx("sfx-button"),

      onPress: () => this.setPressedStyle(),

      onRelease: () => this.resetButton(),
    });

    this.bg = scene.add.image(0, 0, "circle-base-btn").setOrigin(0.5);

    this.labelText = scene.add
      .text(0, 0, options.label, {
        fontFamily: "Black Han Sans",
        fontSize: "46px",
        color: "#1C120E",
      })
      .setOrigin(0.5);

    this.add([this.bg, this.labelText]);

    this.enableButton(this.bg.width, this.bg.height);

    scene.add.existing(this);
  }

  setLabel(label: string) {
    this.labelText.setText(label);
  }

  private setPressedStyle() {
    this.setScale(0.9);
  }

  private resetButton() {
    this.setScale(1);
  }
}
